import React from 'react'
import { Field, reduxForm } from 'redux-form'
import * as Buttons from 'components/theme/Buttons'
import { renderTextField, FileInput } from 'components/forms/formComponents'
import { FormWrapper } from 'components/theme/FormWrapper'
import HubspotForm from 'components/forms/hubspot/default'

const validate = values => {
  const errors = {}

  if (!values.email) {
    errors.email = `Veuillez indiquer votre adresse email`
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Votre adresse email semble invalide'
  }
  if (!values.name) {
    errors.name = `Veuillez indiquer votre nom`
  }
  if (!values.firstname) {
    errors.firstname = `Veuillez indiquer votre prénom`
  }
  if (!values.enseigne) {
    errors.enseigne = `Veuillez indiquer le nom de l'enseigne`
  }
  return errors
}

const ContactForm = ({ handleSubmit, pristine, submitting, label, page, hubspotId }) => (
  <React.Fragment>
    {
      hubspotId ? (
        <HubspotForm id={hubspotId} />
      ) : (
          <FormWrapper>
            <form onSubmit={handleSubmit}>
              <div className="default-form-wrapper">
                <Field name="name" type="text" component={renderTextField} label="Nom" />
                <Field name="firstname" type="text" component={renderTextField} label="Prénom" />
                <Field name="email" type="email" component={renderTextField} label="Email professionnel" />
                {
                  page === 'campagnes-trade-activation' && (
                    <React.Fragment>
                      <Field name="phone" type="text" component={renderTextField} label="N° de téléphone" />
                    </React.Fragment>
                  )
                }
                <Field name="entreprise" type="text" component={renderTextField} label="Entreprise" />
                {
                  page === 'media-for-good' && (
                    <div style={{ marginTop: '3rem' }}>
                      <Field name="image" label="Votre photo" type="file" component={FileInput} />
                    </div>
                  )
                }
              </div>
              <center>
                <Buttons.ButtonDefault
                  type="submit"
                  className="medium"
                  // style={{ background: '#1464ff', marginTop: '4rem' }}
                  style={{ marginTop: '4rem' }}
                  disabled={pristine || submitting}
                >
                  {label ? label : 'Envoyer'}
                </Buttons.ButtonDefault>
              </center>
            </form>
          </FormWrapper>
        )
    }
  </React.Fragment>
)

export default reduxForm({
  form: 'contactForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(ContactForm)
